document.addEventListener('DOMContentLoaded', function() {
  function stickyProductButton() {
    let opened = false;
    if(window.innerWidth < 768 && document.querySelector('body').classList.contains('template-product')) {
      window.addEventListener('scroll', function() {
        let btn = document.querySelector('.ProductForm__AddToCart');
        let pos = document.querySelector('.ProductForm__QuantitySelector').getBoundingClientRect().top;
        if(pos < - 54 && opened == false) {
          opened = true;
          btn.classList.add('fixed');
          document.querySelector('.ProductForm__QuantitySelector').classList.add('opened')
        }
        else if(pos >= -54 && opened == true) {
          opened = false;
          btn.classList.remove('fixed');
          document.querySelector('.ProductForm__QuantitySelector').classList.remove('opened')
        }
      })
    }
  }

  function productSlider() {
    new Flickity(document.querySelector('.product__thumbnails'), {
      asNavFor: '.Product__Slideshow',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

  }

  function mosaicContent() {
    if(document.getElementById('mosaic') && document.getElementsByClassName('product__mosaic')[0]) {
      document.getElementById('mosaic').appendChild(document.getElementsByClassName('product__mosaic')[0])
    }
  }

  function linklookContent() {
    if(document.getElementById('linklook') && document.getElementsByClassName('product__linklook')[0]) {
      document.getElementById('linklook').appendChild(document.getElementsByClassName('product__linklook')[0])
    }
  }

  function cookieWhatsapp() {
    const target = document.querySelector('body');
    const config = {
      subtree: true,
      childList: true,
    };

    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if($('.eapp-whatsapp-chat-root-layout-component').length) {
          if($('.llcnCH').length) {
            $('a[title="WhatsApp"]').attr('target', '_blank');
            if (Cookies.get('hidden-whatsapp') == 'true') {
              observer.disconnect();
              $('.llcnCH').css('display', 'none');
              setTimeout(function () {
                $('.Close__Component-sc-1l05yq5-0').trigger('click');
                $('.Window__WindowComponent-sc-17wvysh-1').css('display', 'flex');
                Cookies.set('hidden-whatsapp', 'true');
              }, 1000)
            }
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(target, config);

    document.addEventListener( "click", someListener );
    function someListener(event){
      var element = event.target;
      if(element.classList.contains("Close__Component-sc-1l05yq5-0")) {
        Cookies.set('hidden-whatsapp', 'true');
      }
      if(element.closest('.Bubble__BubbleComponent-sc-83hmjh-2')){
        Cookies.set('hidden-whatsapp', 'false');
        if(document.querySelector('.Window__WindowComponent-sc-17wvysh-1').classList.contains('llcnCH')) {
          Cookies.set('hidden-whatsapp', 'true');
        }
      }
    }
  }
  
  document.addEventListener('MAKEBECOOL_BUNDLES.updateCart', () => { 
    window.location.href = '/cart' 
  })


  productSlider();
  stickyProductButton();
  mosaicContent();
  linklookContent();
  cookieWhatsapp();
})
